import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@app/shared/data';
import { NewOrganisationComponent } from '@app/shared/ui';
import { environment } from '@env';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-start',

  templateUrl: './start.html',
  imports: [CommonModule, RouterModule, ButtonModule, CardModule, NewOrganisationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartComponent {
  readonly organisationAlias = environment.businessInfo.organisationAlias;

  readonly isPublicSignup = environment.businessInfo.enablePublicSignup;

  readonly contactEmail = environment.businessInfo.contactInfo.email;

  private readonly _authService = inject(AuthService);

  signOut(): void {
    this._authService.logout();
  }
}
